<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-6">
            <h4 qid="rr-view-page-title" class="mb-3">
              {{ retentionRule.name }}
            </h4>
            <div class="mb-2">
              <span v-if="getGuide('retention_rule')">
                <GuideButton :guide="getGuide('retention_rule')"></GuideButton>
              </span>
            </div>
          </div>

          <div class="col-md-6 text-right" qid="view-rr-modified">
            <div class="mb-4">
                <span class="h6 ml-3">
                <span v-if="isGranted([permissions.RETENTION_RULE_EDIT, permissions.RETENTION_RULE_EDIT_OWN], retentionRule.created_by) && (!getClient.parent || (getClient.parent && retentionRule.partition))"
                      class="btn btn-edit"
                      qid="edit-rr-button"
                      @click="showEditRRModal(retentionRule)"
                >
                  <font-awesome-icon icon="pen"/>
                </span>
                <span v-if="isGranted([permissions.RETENTION_RULE_DELETE, permissions.RETENTION_RULE_DELETE_OWN], retentionRule.created_by) && (!getClient.parent || (getClient.parent && retentionRule.partition))"
                      class="btn btn-delete"
                      qid="delete-rr-button"
                      @click="showConfirmDeleteModal(retentionRule)"
                >
                  <font-awesome-icon icon="trash-alt"/>
                </span>
              </span>
            </div>
            <div>
              <span>{{ $t('table.last_updated') }}</span>
              <span class="ml-2 text-muted small" qid="view-rr-modified-date">
              {{ retentionRule.updated_at | formatDate }}
            </span>
              <Avatar v-if="retentionRule.updated_by" :object="retentionRule.updated_by" size="xs" class="ml-3 mr-2"></Avatar>
              <span v-if="retentionRule.updated_by" qid="view-rr-modified-by">
              {{ retentionRule.updated_by.name }}
            </span>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="content-view-body">
          <br>
          <div class="mt-3">
            <p class="text-dark">
              {{ $t('maintenance.retention_rules.create.description_label') }}
            </p>
            <hr>
            <p qid="rr-description" class="text-formatted">
              {{ retentionRule.description }}
            </p>
            <br>
          </div>
          <div class="mt-2">
            <p class="text-dark">
              {{ $t('maintenance.retention_rules.create.time_limit_label') }}
            </p>
            <hr>
            <p qid="rr-time-limit">
              {{ retentionRule.time_limit }}
            </p>
            <br>
          </div>
          <div class="mt-2">
            <p class="text-dark">
              {{ $t('maintenance.retention_rules.create.attachments') }}
              &nbsp;
              <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
            </p>
            <hr>
            <b-alert v-if="error.length"
                     show
                     variant="danger"
                     qid="attachments-rr-error"
            >
              {{ error }}
            </b-alert>
            <p v-for="file in retentionRule.media">
              <button class="float-right btn btn-link btn-inline-icons"
                      @click="openDeleteAttachmentModal(file)"
                      qid="remove-media-item"
                      v-if="isGranted([permissions.RETENTION_RULE_EDIT, permissions.RETENTION_RULE_EDIT_OWN], retentionRule.created_by) && (!getClient.parent || (getClient.parent && retentionRule.partition))"
              >
                <font-awesome-icon icon="trash-alt" />
              </button>
              <span class="mr-3 float-right text-muted cursor-pointer"
                    @click="downloadMedia(file)"
                    qid="download-media"
              >
                <font-awesome-icon icon="cloud-download-alt" />
              </span>
              <a href="#" @click="downloadMedia(file)" qid="create-rr-media-item">
                {{ file.file_name }}
              </a>
            </p>
            <label v-if="isGranted([permissions.RETENTION_RULE_EDIT, permissions.RETENTION_RULE_EDIT_OWN], retentionRule.created_by) && (!getClient.parent || (getClient.parent && retentionRule.partition))"
                   class="btn btn-secondary cursor-pointer"
                   qid="create-rr-file-button"
            >
              <input type="file"
                     name="fileupload"
                     value="fileupload"
                     multiple
                     id="file"
                     @change="onFileChange"
                     @click="resetFile"
              >
              <span>
                <font-awesome-icon icon="cloud-upload-alt" />
                {{ $t('attachments.upload_button') }}
              </span>
            </label>
            <br>
          </div>
          <div class="mt-4">
            <p class="text-dark">
              {{ $t('maintenance.retention_rules.create.links_label') }}
            </p>
            <hr>
            <div v-if="retentionRule.links">
              <p v-for="link in retentionRule.links" >
                <button class="float-right btn btn-link btn-inline-icons"
                        @click="openDeleteLinkModal(link)"
                        qid="view-rr-remove-link"
                        v-if="isGranted([permissions.RETENTION_RULE_EDIT, permissions.RETENTION_RULE_EDIT_OWN], retentionRule.created_by) && (!getClient.parent || (getClient.parent && retentionRule.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </button>
                <a :href="link.url" target="_blank" qid="create-rr-link-item">
                  {{ link.name ? link.name : link.url }}
                </a>
              </p>
            </div>
            <div v-if="showInput">
              <label class="mt-2">{{ $t('system.link') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLink"
                :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                qid="create-p-links"
              ></b-form-input>
              <label class="mt-2">{{ $t('table.name') }}</label>
              <b-form-input
                type="text"
                aria-describedby="inputGroup"
                v-model="inputLinkName"
                :placeholder="inputLink ? inputLink : $t('table.name')"
                qid="create-p-links"
              ></b-form-input>
              <div class="text-right mt-2">
                <span class="btn btn-success cursor-pointer mr-0"
                      id="inputGroup"
                      @click="handleLink"
                      qid="handle-link-save"
                >
                  {{ $t('system.save') }}
                </span>
              </div>
            </div>
            <span class="btn btn-link cursor-pointer"
                  @click="showInput = true"
                  qid="add-another-link"
                  v-if="isGranted([permissions.RETENTION_RULE_EDIT, permissions.RETENTION_RULE_EDIT_OWN], retentionRule.created_by) && (!getClient.parent || (getClient.parent && retentionRule.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
            </span>
            <br>
          </div>
        </div>
      </div>
    </div>


    <!-- Edit retention rule modal template -->
    <b-modal ref="edit-retention-rule" hide-footer>
      <div class="d-block text-center">
        <h4 qid="update-rr-title">
          {{ $t('maintenance.retention_rules.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-rr-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editRRFormSubmit" qid="edit-rr-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-rr-name-label">
              {{ $t('maintenance.retention_rules.create.name_label') }}
            </label>
            <b-form-input
              qid="edit-rr-form-name"
              type="text"
              v-model="rrForm.name"
              :maxLength="255"
              required
              :placeholder="$t('maintenance.retention_rules.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-rr-description-label">
              {{ $t('maintenance.retention_rules.create.description_label') }}
            </label>
            <b-form-textarea
              qid="edit-rr-form-description"
              v-model="rrForm.description"
              rows="6"
              max-rows="6"
              :placeholder="$t('maintenance.retention_rules.create.description_placeholder')"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group :class="{'multiselect--show-input': timeLimitInput.length}">
            <label qid="edit-rr-type-label">
              {{ $t('maintenance.retention_rules.create.time_limit_label') }}
            </label>
            <multiselect
                v-model="rrForm.time_limit"
                :options="timeLimitItems"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('maintenance.retention_rules.create.time_limit_placeholder')"
                :preserveSearch="true"
                @search-change="handleTimeLimitInput"
                track-by="time_limit"
                label="time_limit"
                qid="edit-rr-form-time-limit"
            >
              <template slot="noResult" slot-scope="props">
                {{ $t('maintenance.retention_rules.create.time_limit_no_results') }}
              </template>
            </multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditRRModal"
                    qid="edit-rr-cancel-button"
          >
            {{ $t('maintenance.retention_rules.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="edit-rr-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('maintenance.retention_rules.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Delete retention rule confirm modal template -->
    <b-modal ref="delete-retention-rule" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-rr-title">
          {{ $t('maintenance.retention_rules.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('maintenance.retention_rules.delete.description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('maintenance.retention_rules.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="delete-rr-cancel-button"
        >
          {{ $t('maintenance.retention_rules.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteRR(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-rr-submit-button"
                  v-if="isGranted([permissions.RETENTION_RULE_DELETE, permissions.RETENTION_RULE_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
        >
          {{ $t('maintenance.retention_rules.delete.submit') }}
        </b-button>
      </div>
    </b-modal>

    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js'
import {config} from '@/config.js'
import Avatar from '@/components/Avatar.vue';
import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
import GuideButton from '@/components/guide/GuideButton.vue';


export default {
  name: 'RetentionRuleView',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('maintenance.title'),
          to: '/maintenance'
        },
        {
          text: this.$t('maintenance.retention_rules.title'),
          to: '/maintenance/retention-rules'
        }
      ],
      retentionRule: {},
      showInput: false,
      showSingleLinkLabel: true,
      inputLink: '',
      inputLinkName: '',
      itemToDelete: {},
      rrForm: {
        name: '',
        description: '',
        time_limit: [],
        client:'',
      },
      error: '',
      timeLimitItems: [],
      timeLimitInput: '',
      buttonDisabled: false,
      selectedFile: {},
      selectedLink: {},
      showDeleteAttachmentModal: false,
      showDeleteLinkModal: false,
      myGuides: [],
    }
  },
  computed: {
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {
    // Watch when client changes in store and trigger api reload
    getClient: function (newValue, oldValue) {
      if (newValue && oldValue && newValue.slug !== oldValue.slug) {
        this.goToList()
      } else {
        this.loadContent();
        this.loadLimits();
      }
    }
  },
  components: {
    Avatar,
    ConfirmRemoveAttachment,
    GuideButton
  },
  methods: {
    goToList() {
      this.$router.push('/maintenance/retention-rules')
    },
    resetFile() {
      let imagefile = document.querySelector('#file');
      imagefile.value = '';
    },
    getGuide(code) {
      let existingGuide = _.find(this.myGuides, function(object) {
        return object.scope == code && object.type == 'Maintenance' && object.enabled
      });
      return existingGuide
    },
    loadGuides(code) {
      let self = this;
      let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

      piincHttp.get('guides', { params:
        {
          per_page: 1,
          language: 'en',
          type: 'Maintenance',
          scope: code,
          client: this.getClient.slug
        }
      }).then(function(response) {
        if (response.data.items.length) {
          self.myGuides.push(response.data.items[0])
        }
      }, function() {});
    },
    loadContent() {
      let self = this;
      piincHttp.get('retention-rules/' + this.$route.params.slug, { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.retentionRule = response.data;
        // Push content name in breadcrumb array
        self.breadcrumbItems.push({text: self.retentionRule.name, active: true});
      }, function() {});
    },
    openDeleteAttachmentModal(object) {
      this.selectedFile = object
      this.showDeleteAttachmentModal = true
    },
    closeDeleteAttachmentModal () {
      this.selectedFile = {}
      this.showDeleteAttachmentModal = false;
      // Remove last item in breadcrumbs, because it will be added again on load content
      this.breadcrumbItems.pop();
      this.loadContent();
    },
    openDeleteLinkModal(object) {
      this.selectedLink = object
      this.showDeleteLinkModal = true
    },
    closeDeleteLinkModal () {
      this.selectedLink = {}
      this.showDeleteLinkModal = false;
      // Remove last item in breadcrumbs, because it will be added again on load content
      this.breadcrumbItems.pop();
      this.loadContent();
    },
    handleTimeLimitInput(input) {
      this.timeLimitInput = input;
    },
    handleLink() {
      let self = this;
      let formData = new FormData();

      if (!this.inputLink.startsWith('http')) {
        this.inputLink = 'http://' + this.inputLink
      }

      formData.append("url", this.inputLink);
      formData.append("name", this.inputLinkName);
      formData.append("model_type", this.retentionRule.who_am_i);
      formData.append("model_id", this.retentionRule.id);

      piincHttp.post('links', formData).then(function() {
        // Remove last item in breadcrumbs, because it will be added again on load content
        self.breadcrumbItems.pop();
        self.$toastr('success', self.$t('maintenance.retention_rules.link_add_success'))
        self.loadContent()
        self.inputLink = ''
        self.inputLinkName = ''
        self.showInput = false
      }, function() {})
    },
    downloadMedia(object){
      piincHttp.get('documents/' + object.id + '/download', {responseType: 'blob'}).then(function(response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.download = object.file_name;

        link.click();
        link.remove()
        window.URL.revokeObjectURL(url);
      }, function() {});
    },
    onFileChange(file) {
      let files = file.target.files;
      let self = this;
      let formData = new FormData();
      let sizeError = false;

      for (var i = 0; i < files.length; i++) {
        // Equal to 10 MB
        if (files[i].size > 10485760) {
          sizeError = true;
        }
        formData.append('document[]', files[i]);
      }

      formData.append("name", "documents");
      formData.append("model_type", this.retentionRule.who_am_i);
      formData.append("model_id", this.retentionRule.id);

      if (sizeError) {
        this.error = this.$t('system.file_size')
      } else {
        piincHttp.post('documents', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(function() {
          // Remove last item in breadcrumbs, because it will be added again on load content
          self.breadcrumbItems.pop();
          self.$toastr('success', self.$t('maintenance.retention_rules.media_add_success'))
          self.error = ''
          self.loadContent()
        }, function(error) {
          self.error = error.data.message;
          if (error.data.errors['document.0']) {
            self.error += ' ' + error.data.errors['document.0'][0]
          }
        })
      }
    },
    getUserAvatar(user){
      if (user && user.avatar) {
        return user.avatar;
      } else {
        return require('@/assets/avatar.png');
      }
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-retention-rule'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {}
      this.$refs['delete-retention-rule'].hide()
    },
    confirmDeleteRR(object) {
      let self = this;
      piincHttp.delete('retention-rules/' + object.slug).then(function() {
        self.hideConfirmDeleteModal();
        self.goToList();
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('maintenance.retention_rules.delete.success'))
      }, function() {});
    },
    showEditRRModal(object) {
      let self = this;

      // Preselect category on edit modal
      if (object.time_limit) {
        this.rrForm.time_limit = []
        _.find(this.timeLimitItems, function(item) {
          if (item.time_limit == object.time_limit) {
            self.rrForm.time_limit = item;
          }
        });
      }

      this.rrForm.slug = object.slug;
      this.rrForm.name = object.name;
      this.rrForm.description = object.description;

      this.$refs['edit-retention-rule'].show()
    },
    hideEditRRModal() {
      this.timeLimitInput = ''
      this.$refs['edit-retention-rule'].hide()
    },
    editRRFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();
      this.rrForm.client = this.getClient.slug;

      if (this.timeLimitInput && this.timeLimitInput.length) {
        this.rrForm.time_limit = this.timeLimitInput
      } else {
        if (this.rrForm.time_limit && this.rrForm.time_limit.time_limit) {
          this.rrForm.time_limit = this.rrForm.time_limit.time_limit
        } else {
          this.rrForm.time_limit = '';
        }
      }

      piincHttp.put('retention-rules/' + this.rrForm.slug, this.rrForm).then(function(response) {
        self.hideEditRRModal();
        self.buttonDisabled = false;
        // If slug is not changed, just reload content
        if (response.data.slug === self.retentionRule.slug) {
          // Remove last item in breadcrumbs, because it will be added again on load content
          self.breadcrumbItems.pop();
          self.loadContent();
        } else {
          // If slug changed, reload state with new param
          self.$router.push({ name: 'maintenance.retention_rules.view', params: { slug: response.data.slug }})
        }
        self.$toastr('success', self.$t('maintenance.retention_rules.update.success'))
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    loadLimits() {
      let self = this;
      piincHttp.get('retention-rules/limits', { params:
        {
          client: this.getClient.slug
        }
      }).then(function(response) {
        self.timeLimitItems = response.data
        if (self.timeLimitItems && !self.timeLimitItems.length) {
          self.timeLimitItems.push({time_limit: self.$t('system.no_results'), $isDisabled: true})
        }
      }, function() {});
    }
  },
  created () {
    if (this.getClient && this.getClient.slug) {
      this.loadContent();
      this.loadLimits();
    }
    this.loadGuides('retention_rule');
  }
}
</script>
